import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHashtagRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.636 5.36a1.125 1.125 0 0 0-2.198-.472L11.34 10H7.21c-.623 0-1.125.501-1.125 1.124s.502 1.125 1.125 1.125h3.647L9.25 19.746H5.125c-.623 0-1.125.502-1.125 1.125s.502 1.125 1.125 1.125h3.642l-.994 4.638a1.125 1.125 0 0 0 2.199.474L11.069 22h7.284l-.994 4.64a1.124 1.124 0 0 0 2.199.472l1.097-5.107h4.125c.623 0 1.125-.502 1.125-1.125s-.502-1.124-1.125-1.124h-3.643l1.608-7.498h4.13c.623 0 1.125-.501 1.125-1.124s-.502-1.125-1.125-1.125h-3.647l.994-4.639a1.125 1.125 0 0 0-.863-1.335 1.126 1.126 0 0 0-1.34.853L20.922 10h-7.285l.994-4.64zm-1.477 6.889h7.285l-1.608 7.497h-7.284z" })
});
export default SvgHashtagRegularIcon;
